<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.media.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.media.title') }} </span>
                </div>
                <div class="">
                    Un numar mai mare de imagini va pot aduce mai multe rezervari
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <div v-if="item.static.images.length">
            <v-carousel hide-delimiters light height="150">
                <v-carousel-item v-for="(image,i) in item.static.images" :key="i" class="carousel-test">
                    <img :src="image.url" alt="" height="150" width="auto">
                </v-carousel-item>
            </v-carousel>
        </div>
        <div v-else>
            {{ $t('hotel.card.media.no_data') }}
        </div>
    </v-card-text>

    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="">
                    Un numar mai mare de imagini va pot aduce mai multe rezervari
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        active: Object,
    },
    name: `hotel-media`,
    components: {},
    data() {
        return {
            status_dialog: false,
            color: 'grey',
            hover: false,
        };
    },

    watch: {},
    computed: {
        procent_status() {
            let procent = 0;
            let length_value = this.item.static.images.length;
            if(length_value < 6) {
                procent += 50;
            }
            if(length_value > 5 && length_value < 11) {
                procent += 80;
            }
            if(length_value > 11 && length_value < 15) {
                procent += 90;
            }
            if(length_value > 15) {
                procent += 100;
            }

            this.setColor(procent);

            return procent;
        }
    },
    mounted() {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }

    },
};
</script>
<style lang="stylus">
.v-window
    &.v-carousel
        box-shadow: none
.v-window-item
    .v-carousel__item
        &.v-image
            .v-responsive__content
                display: flex
                justify-content: center
</style>
